<ur-product-card
    [title]="resolvedTitle()"
    [brandName]="resolvedBrandName()"
    [teaserHtml]="resolvedTeaserHtml()"
    [image]="resolvedImage()"
    [link]="resolvedLink()"
    [tags]="resolvedTags()"
    [manufacturer]="resolvedManufacturer()"
    [attributes]="resolvedAttributes()"
    (clicked)="onClick()" />
